import Sidebar from "../../shared/app-shell/Sidebar";
import { themeAtom } from "../../shared/atoms";
import LandingPageTF from "../../tech-form/pages/LandingPageTF";
import { useAtomValue } from "jotai";
import React from "react";
import { twMerge } from "tailwind-merge";

const ExternalLandingPage: React.FC = () => {
  const theme = useAtomValue(themeAtom);
  return (
    <div className={twMerge("flex h-screen", theme.home.tailwind.pageBackground)}>
      <Sidebar />
      <div className="flex-1">
        <LandingPageTF />
      </div>
    </div>
  );
};

export default ExternalLandingPage;
